import React from 'react';
import { connect } from 'react-redux';
import {
    withRouter
} from 'react-router-dom'
import {Link} from 'react-router-dom';
import TextField from '@material-ui/core/TextField';
//import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
//import FormControlLabel from '@material-ui/core/FormControlLabel';
import IntlMessages from 'util/IntlMessages';
import LogoColor from 'assets/images/logo_color.svg';
//import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import {checkEmail,login,register,loginWithFacebook} from 'api/index';
import {passwordRecovery} from 'actions/Api';
import EmailValidator from 'email-validator';
import Loader from 'react-loader-advanced';
import { PulseLoader } from 'react-spinners';

var passwordValidator = require('password-validator');

class MyLogin extends React.Component {
    state = {
        activeStep: 0,
        email: '',
        password: '',
        fbConnected: null,
    };

    constructor(props) {
        super(props);

        this.passwordSchema = new passwordValidator();
        this.passwordSchema
            .is().min(8)                                    // Minimum length 8
            .is().max(100)                                  // Maximum length 100
            .has().uppercase()                              // Must have uppercase letters
            .has().lowercase()                              // Must have lowercase letters
            .has().digits()                                 // Must have digits
            .is().not().oneOf(['Passw0rd', 'Password123']); // Blacklist these values
    }

    componentDidMount() {
    }

    handleReset = () => {
        this.setState({
            activeStep: 0,  // 0=email, 1=password, >1=password (but already tried to login)
            email: '',
            password: ''
        });
    };

    getPassword() {
        return <TextField
            type="password"
            id="password"
            label={<IntlMessages id="components.MyLogin.password"/>}
            fullWidth
            defaultValue={this.state.password}
            onChange={(event) => this.setState({password: event.target.value})}
            margin="normal"
            className="mt-1"
        />
    }

    getEmail() {
        return <div>
            <TextField
                id="email"
                label={<IntlMessages id="components.MyLogin.email"/>}
                fullWidth
                onChange={(event) => this.setState({email: event.target.value})}
                defaultValue={this.state.email}
                margin="normal"
                className="mt-1"
            />
        </div>
    }

    handleNext = () => {
        if (this.state.activeStep===0) {
            // check email and go to password
            this.props.dispatch(checkEmail(this.props.apiUrl,{ email: this.state.email }));
        }
        if (this.state.activeStep>0) {
            if (this.props.emailExists) {
                // email exists and password given, so try to log in
                this.props.dispatch(login(this.props.apiUrl,{ username: this.state.email, password: this.state.password }));
            } else {
                // email does not exists and password given, so try to create a new account
                this.props.dispatch(register(this.props.apiUrl,{ username: this.state.email, password: this.state.password }));
            }
        }
        this.setState({activeStep: this.state.activeStep+1},()=>{
/*            if (this.state.activeStep > 0) {
                this.refs['password'].focus();
            }*/
        });
    };

    handleBack = () => {
        this.setState({activeStep: 0});
    };

    getStepContent(stepIndex) {
        switch (stepIndex) {
            case 0:
                return this.getEmail();
            case 1:
                return this.getPassword();
            default:
                return <IntlMessages id="components.MyLogin.success"/>;
        }
    }

    handleFacebookLogin = () => {
        console.log('MY: login via facebook');
        this.props.dispatch({ type: 'set_api_loading' });
        FB.login();
/*
        FB.getLoginStatus(function(response) {
            if (response.status === "connected") {
                // already logged in
                FB.api('/me?fields=email,name,first_name,last_name', function(response2) {
                    console.log('MY: re-logging in using facebook');
                    // connected, so continue to login
                    this.props.dispatch(loginWithFacebook(this.props.apiUrl, this.props.session, { userId: response.authResponse.userID, email: response2.email, name: response2.name, firstName: response2.first_name, lastName: response2.last_name, accessToken: response.authResponse.accessToken }));
                }.bind(this));
            } else {
                console.log('MY: logging in using facebook');
                FB.login();
            }
        }.bind(this), true);
*/
    };

    handlePasswordRecovery = () => {
        console.log('MY: password recovery');
        this.props.dispatch(passwordRecovery(this.state.email));

//        this.props.dispatch({ type: 'set_api_loading' });
    };

    handleChange = name => event => {
        event.preventDefault();
        this.setState({
            [name]: event.target.value,
        },()=>{
//            console.log(event);
        });
    };

    handleInputKeyDown = (e) => {
        if (e.keyCode === 13) {
//            console.log('enter');
            if (typeof e.preventDefault === "function") {
                e.preventDefault();
            }

            this.handleNext();
//            this.refs[this.fieldOrder[e.target.name]].focus();
        }
    };

    disableNext = () => {
        if (this.state.activeStep === 0) {
            // email
            return !EmailValidator.validate(this.state.email); 
        } else {
            // password
            return !this.isValidPassword(this.state.password); 
        }
    };

    isValidPassword = (pass) => {
        return this.passwordSchema.validate(pass);
    };

    render() {
        const steps = 2;
        const {activeStep} = this.state;
        return (
            <div className="app-main-container">
                <main className="app-main-content-wrapper">
                    <div className="app-main-content">
                        <div className="login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3">
                            <Loader 
                                show={this.props.apiLoading}
                                message={<PulseLoader loading color={'#29465E'}/>} 
    //                            backgroundStyle={{paddingTop: '100px', paddingBottom: '100px'}} 
                                foregroundStyle={{color: '#29465E'/*, marginTop: '100px', marginBottom: '100px'*/}} 
                                contentBlur={2}>
                                <div className="login-content">
                                    <div className="login-header mb-4">
                                        <Link className="app-logo" to="/" title="Jambo">
                                            <img src={LogoColor} alt="jambo" title="jambo"/>
                                        </Link>
                                    </div>

                                    <div className="login-form">
                                        {
                                            <form>
                                                <fieldset>
                                                    {
                                                        this.props.fbLoginFailed &&
                                                        <div style={{color: 'red', marginBottom: '10px'}}>
                                                            <IntlMessages id="components.MyLogin.facebookFailure"/><br/> 
                                                            <IntlMessages id="components.MyLogin.facebookFailureText"/>
                                                        </div>
                                                    }

                                                    {
                                                        this.state.activeStep === 0 &&
                                                        <div>
                                                            <TextField
                                                                id="email"
                                                                label={<IntlMessages id="components.MyLogin.email"/>}
                                                                fullWidth
    //                                                            onChange={(event) => this.setState({email: event.target.value})}
                                                                onChange={this.handleChange('email')}
                                                                onKeyDown={this.handleInputKeyDown}
                                                                defaultValue={this.state.email}
                                                                margin="normal"
                                                                className="mt-1"
                                                                autoComplete="username"
                                                            />
                                                        </div>
                                                    }
                                                    <div>
                                                        {
                                                            this.state.activeStep === 1 && this.props.emailExists===false &&
                                                            <div>
                                                                <IntlMessages id="components.MyLogin.register"/>
                                                            </div>
                                                        }
                                                        {
                                                            this.state.activeStep > 1 && this.props.loginFailure &&
                                                            <div style={{color: 'red', marginBottom: '10px'}}>
                                                                <IntlMessages id="components.MyLogin.loginFailure"/>
                                                            </div>
                                                        }
                                                        {
                                                            this.state.activeStep > 0 &&
                                                            <TextField
                                                                type="password"
                                                                id="password"
                                                                autoFocus
                                                                error={this.state.activeStep === 1 && this.props.emailExists===false && !this.isValidPassword(this.state.password)}
                                                                helperText={this.state.activeStep === 1 && this.props.emailExists===false && !this.isValidPassword(this.state.password)?<IntlMessages id="components.MyLogin.safePassAdvice"/>:null}                    
                                                                label={<IntlMessages id="components.MyLogin.password"/>}
                                                                fullWidth
                                                                defaultValue={this.state.password}
    //                                                            onChange={(event) => this.setState({password: event.target.value})}
                                                                onChange={this.handleChange('password')}
                                                                onKeyDown={this.handleInputKeyDown}
                                                                margin="normal"
                                                                className="mt-1"
                                                                autoComplete={this.props.emailExists?"current-password":"new-password"}
                                                            />
                                                        }
                                                    </div>

                                                    <div className="d-flex justify-content-center" style={{marginTop: '15px'}}>
                                                        {
                                                            this.state.activeStep > 0 &&
                                                            <Button variant="raised" className="jr-btn text-white bg-grey" onClick={this.handleBack}>
                                                                <IntlMessages id="components.MyLogin.back"/>
                                                            </Button>
                                                        }
                                                        <Button 
                                                            variant="raised" 
                                                            className="jr-btn text-white bg-secondary" 
                                                            onClick={this.handleNext}
                                                            className={this.disableNext()?"jr-btn jr-btn-sm lighten-1 text-white":"jr-btn jr-btn-sm bg-secondary lighten-1 text-white"}
                                                            disabled={this.disableNext()}
                                                        >
                                                            <IntlMessages id="components.MyLogin.next"/>
                                                        </Button>
                                                    </div>

                                                    <div className="d-flex justify-content-center" style={{margin: '15px'}}>
                                                        <IntlMessages id="components.MyLogin.or"/>
                                                    </div>

                                                    {
                                                        (this.state.activeStep == 0 || (this.state.activeStep > 0 && this.props.emailExists===false)) &&
                                                        <div className="d-flex justify-content-center">
                                                            <Button 
                                                                variant="raised" 
                                                                className="jr-btn bg-indigo lighten-1 text-white"
                                                                onClick={this.handleFacebookLogin}
                                                            >
                                                                <i className="zmdi zmdi-facebook zmdi-hc-fw" />
                                                                <span><IntlMessages id="components.MyLogin.loginWithFacebook"/></span>
                                                            </Button>
                                                        </div>
                                                    }
                                                    {
                                                        this.state.activeStep > 0 && this.props.emailExists &&
                                                        <div className="d-flex justify-content-center">
                                                            <Button size="small" color="primary" onClick={this.handlePasswordRecovery}>
                                                                <span><IntlMessages id="components.MyLogin.forgotPassword"/></span>
                                                            </Button>
                                                        </div>
                                                    }
                                                </fieldset>
                                            </form>
                                        }
                                    </div>
                                </div>
                            </Loader>
                        </div>
                    </div>
                </main>
            </div>
        );
    }
}

const mapStateToProps = function(state){
    return {
        apiUrl: state.api.url,
        session: state.api.session,
        emailExists: state.api.emailExists,
        loginFailure: state.api.loginFailure,
        fbLoginFailed: state.api.fbLoginFailed,
        apiLoading: state.api.isLoading,
    }
}

export default withRouter(connect(mapStateToProps)(MyLogin));
